import BaseEntity from './BaseEntity';
export default class User extends BaseEntity {
    constructor(data) {
        super();
        this.bitbucketAvatar = this.parseProperty(data, 'bitbucketAvatar');
        this.displayName = this.parseProperty(data, 'displayName');
        this.gitlabAvatar = this.parseProperty(data, 'gitlabAvatar');
        this.id = this.parseProperty(data, 'id');
        this.timezoneId = this.parseProperty(data, 'timezoneId');
        this.username = this.parseProperty(data, 'username');
        this.vcs = this.parseProperty(data, 'vcs');
        this.skipTaskOrganisationInvite = this.parseProperty(data, 'skipTaskOrganisationInvite');
    }
}
